// FETCH PAGES
export const FETCH_PAGES_REQUEST = 'siteDesigner/FETCH_PAGES_REQUEST';
export const FETCH_PAGES_COMPLETED = 'siteDesigner/FETCH_PAGES_COMPLETED';
export const FETCH_PAGE_BY_ID_REQUEST = 'siteDesigner/FETCH_PAGE_BY_ID_REQUEST';
export const FETCH_PAGE_BY_ID_COMPLETED = 'siteDesigner/FETCH_PAGE_BY_ID_COMPLETED';
export const CREATE_PAGE_COMPLETED = 'siteDesigner/CREATE_PAGE_COMPLETED';
export const DELETE_PAGE_COMPLETED = 'siteDesigner/DELETE_PAGE_COMPLETED';
export const TOGGLE_VISIBILITY_PAGE_COMPLETED = 'siteDesigner/TOGGLE_VISIBILITY_PAGE_COMPLETED';
export const FETCH_PAGE_DIFFERENT_ACCESS_COMPLETED = 'siteDesigner/FETCH_PAGE_DIFFERENT_ACCESS_COMPLETED';
export const PUBLISH_DRAFT_CONTENT_REQUEST = 'siteDesigner/PUBLISH_DRAFT_CONTENT_REQUEST';
export const UPDATE_PAGE_COMPLETED = 'siteDesigner/UPDATE_PAGE_COMPLETED';
export const SET_CURRENT_PAGE = 'siteDesigner/SET_CURRENT_PAGE';
export const FETCH_SAVE_AS_DRAFT_REQUEST = 'siteDesigner/FETCH_SAVE_AS_DRAFT_REQUEST';
export const UPDATE_PAGE_SECTIONS_COMPLETED = 'siteDesigner/UPDATE_PAGE_SECTIONS_COMPLETED';
export const UPDATE_CURRENT_SECTION_UUID_COMPLETED = 'siteDesigner/UPDATE_CURRENT_SECTION_UUID_COMPLETED';
export const STATE_UPDATE_ACTION = 'siteDesigner/STATE_UPDATE_ACTION';
export const DELETE_SECTION_COMPLETED = 'siteDesigner/DELETE_SECTION_COMPLETED';
export const TOGGLE_VISIBILITY_SECTIONS_COMPLETED = 'siteDesigner/TOGGLE_VISIBILITY_SECTIONS_COMPLETED';
export const UPDATE_GLOBAL_SETTINGS_COMPLETED = 'siteDesigner/UPDATE_GLOBAL_SETTINGS_COMPLETED';
export const RESTOR_GLOBAL_SETTINGS_ACTION = 'siteDesigner/RESTOR_GLOBAL_SETTINGS_ACTION';
export const SET_CURRENT_SEGMENT_ACTION = 'siteDesigner/SET_CURRENT_SEGMENT_ACTION';
export const SET_UPDATE_CONTENT_RESOURCES = 'siteDesigner/SET_UPDATE_CONTENT_RESOURCES';
export const UPDATE_PAGE_SECTIONS_ORDER = 'siteDesigner/UPDATE_PAGE_SECTIONS_ORDER';
export const RESTOR_CURRENT_PAGE_ACTION = 'siteDesigner/RESTOR_CURRENT_PAGE_ACTION';
export const RESTOR_PAGE_SECTIONS_ACTION = 'siteDesigner/RESTOR_PAGE_SECTIONS_ACTION';
export const SET_PREPEAR_COMPONENT_FOR_RENDER = 'siteDesigner/SET_PREPEAR_COMPONENT_FOR_RENDER';
